export const textPattern = /[^a-zA-Z0-9_@,-.+&%() ]/g;
export const commentTextPattern = /[^a-zA-Z0-9_@,-.+&%() \n]/g;
export const textWithoutSpacePattern = /[^a-zA-Z0-9_@,-.+&%()]/g;
export const numberPattern = /[^0-9]/g;
export const passwordPattern = /^(?!.*\s)(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
export const commaSeparatedPincodePattern = /^\d{6}(,\d{6})*$/;
export const decimalNumberPattern = /^(?:\d+\.\d+|\d+)$/;
export const urlPattern = /^(https?:\/\/)([\w-]+\.)+[\w-]+(\/[\w\-._~:\/?#[\]@!$&'()*+,;=]*)?$/;
export const passwordInputPattern = /[^a-zA-Z0-9_!@#%^&*()-+={}[]|:;"',.?]/g;
export const imageUrlPattern = /^https:\/\/[^\s]+\.(jpg|jpe?g|png)(?=\?)/i;
export const pdfUrlPattern = /^https:\/\/[^\s]+\.pdf(?=\?)/i;
export const latLongPattern = /^-?(?:[0-8]?\d(?:\.\d+)?|90(?:\.0+)?),-?(?:1[0-7]\d(?:\.\d+)?|[0-9]?\d(?:\.\d+)?|180(?:\.0+)?)$/;
export const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const phoneNumberPattern = /^\d{10}$/;